import { render, staticRenderFns } from "./BookingConfig.vue?vue&type=template&id=52374078&scoped=true"
import script from "./BookingConfig.vue?vue&type=script&lang=js"
export * from "./BookingConfig.vue?vue&type=script&lang=js"
import style0 from "./BookingConfig.vue?vue&type=style&index=0&id=52374078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52374078",
  null
  
)

export default component.exports